import styled from 'styled-components'
import RedirectPage from 'components/Page/RedirectPage'

const RedirectToOrgPage = styled(props => (
  <RedirectPage redirectToOrg {...props} />
))``

export default RedirectToOrgPage
